import { useState } from "react";
import axios from "axios";
import {
    FaEnvelope,
    FaPhone,
    FaGlobe,
    FaXTwitter,
    FaLinkedin,
    FaYoutube,
    FaInstagram,
} from "react-icons/fa6";

export default function Contact() {
    const [form, setForm] = useState({
        name: "",
        email: "",
        message: "",
    });

    const [status, setStatus] = useState("");

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setStatus("Sending...");

        try {
            const res = await axios.post(
                "http://localhost:8000/contact",
                form
            );
            setStatus(res.data.message || "Message sent successfully!");
            setForm({ name: "", email: "", message: "" });
        } catch {
            setStatus("Something went wrong. Please try again later.");
        }
    };

    return (
        <div className="w-full bg-white">
            <div className="max-w-6xl mx-auto px-6 py-14">

                {/* ================= HEADER ================= */}
                <div className="mb-12">
                    <h1 className="text-3xl font-extrabold text-gray-900">
                        Contact BlogySports
                    </h1>
                    <p className="mt-2 text-gray-600 max-w-xl">
                        Have sports tips, feedback, or business inquiries?
                        We’d love to hear from you.
                    </p>
                </div>

                {/* ================= GRID ================= */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-12">

                    {/* ================= CONTACT FORM ================= */}
                    <form
                        onSubmit={handleSubmit}
                        className="border border-red-200 rounded-xl p-6 space-y-5 shadow-sm"
                    >
                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">
                                Your Name
                            </label>
                            <input
                                type="text"
                                name="name"
                                value={form.name}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md
                           focus:outline-none focus:ring-2 focus:ring-red-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">
                                Email Address
                            </label>
                            <input
                                type="email"
                                name="email"
                                value={form.email}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md
                           focus:outline-none focus:ring-2 focus:ring-red-500"
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-semibold text-gray-700 mb-1">
                                Message
                            </label>
                            <textarea
                                rows="4"
                                name="message"
                                value={form.message}
                                onChange={handleChange}
                                required
                                className="w-full px-4 py-2 border border-gray-300 rounded-md
                           focus:outline-none focus:ring-2 focus:ring-red-500"
                            />
                        </div>

                        <button
                            type="submit"
                            className="bg-red-600 text-white px-6 py-2 rounded-md
                         hover:bg-red-700 transition font-semibold"
                        >
                            Submit Message
                        </button>

                        {status && (
                            <p className="text-sm text-gray-600 mt-2">
                                {status}
                            </p>
                        )}
                    </form>

                    {/* ================= CONTACT INFO ================= */}
                    <div className="space-y-6">

                        <div>
                            <h2 className="text-xl font-bold text-gray-900">
                                BlogySports
                            </h2>
                            <p className="text-gray-600">
                                Your trusted global destination for sports news,
                                match updates, analysis, and highlights.
                            </p>
                        </div>

                        {/* EMAIL */}
                        <div className="flex items-center gap-3 text-gray-700">
                            <FaEnvelope className="text-red-600 text-lg" />
                            <span>contact@blogysports.com</span>
                        </div>

                        {/* PHONE */}
                        <div className="flex items-center gap-3 text-gray-700">
                            <FaPhone className="text-red-600 text-lg" />
                            <span>+91 00000 00000</span>
                        </div>

                        {/* WEBSITE */}
                        <div className="flex items-center gap-3 text-gray-700">
                            <FaGlobe className="text-red-600 text-lg" />
                            <span>https://blogysports.com</span>
                        </div>

                        {/* ================= SOCIAL ================= */}
                        <div>
                            <p className="font-semibold text-gray-900 mb-3">
                                Follow Us
                            </p>

                            <div className="flex gap-6 text-3xl">
                                <a
                                    href="https://x.com/blogysports"
                                    aria-label="X"
                                    className="text-black hover:opacity-80 transition"
                                >
                                    <FaXTwitter />
                                </a>

                                <a
                                    href="https://www.linkedin.com/company/blogysports"
                                    aria-label="LinkedIn"
                                    className="text-[#0A66C2] hover:opacity-80 transition"
                                >
                                    <FaLinkedin />
                                </a>

                                <a
                                    href="https://www.instagram.com/blogysports"
                                    aria-label="Instagram"
                                    className="text-[#E1306C] hover:opacity-80 transition"
                                >
                                    <FaInstagram />
                                </a>

                                <a
                                    href="https://www.youtube.com/@blogysports"
                                    aria-label="YouTube"
                                    className="text-[#FF0000] hover:opacity-80 transition"
                                >
                                    <FaYoutube />
                                </a>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
